import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/PaymentDetail.css";

const PaymentDetail = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const exam = state?.exam; // 👈 row data
  const [paymentStatus, setPaymentStatus] = useState(false);

  if (!exam) {
    return <p>डेटा उपलब्ध नाही</p>;
  }


  return (
    <div className="transaction-container">
       <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
         पुस्तक व्यवस्थापन  &gt;&gt; <span>पुस्तक तपशील </span>
        </h3>

        <div className="edit-btnn">
    
          <button className="btn outlinee" onClick={() => navigate(-1)}>
            रद्द करा
          </button>
         <button
  className="primary-btn"
  onClick={() =>
    navigate("/dashboard/bookedit", {
      state: { exam }   
    })
  }
>
  संपादन करा
</button>

        </div>
      </div>

      {/* Form */}
      <div className="form-card">
        <h3 className="form-title">पुस्तक तपशील</h3>

       <div className="form-grid">
  <div className="form-group">
    <label>पुस्तकाचं नाव</label>
    <input type="text" value={exam.name} readOnly />
  </div>

  <div className="form-group">
    <label>विद्यार्थ्याचे नाव</label>
    <input type="text" value={exam.sudname} readOnly />
  </div>

  <div className="form-group">
    <label>पेमेंट तारीख</label>
    <input type="text" value={exam.date} readOnly />
  </div>

  <div className="form-group">
    <label>ट्रान्झॅक्शन आयडी(Optional)</label>
    <input type="text" value="०१२३४५६७८९" readOnly />
  </div>
   <div className="form-group">
    <label>किंमत ₹</label>
    <input type="text" value={exam.amount} readOnly />
  </div>

  <div className="form-group">
    <label>कमिशन %</label>
    <input type="text" value={exam.cumission} readOnly />
  </div>

  <div className="form-group">
    <label>पेमेंट स्थिती</label>
    <input
      type="text"
      className={paymentStatus ? "status-paid" : "status-pending"}
      value={paymentStatus ? "पूर्ण" : "बाकी"}
      readOnly
    />
  </div>
</div>


        {/* Toggle */}
      <div className="toggle-row">
  <span>Change Payment Status :</span>
  <label className="switch">
   <input
  type="text"
  className={`payment-status ${
    paymentStatus ? "status-paid" : "status-pending"
  }`}
  value={paymentStatus ? "जमा" : "बाकी"}
  readOnly
/>

    <span className="slider"> </span>
  </label>
</div>

      </div>
    </div>
  );
};

export default PaymentDetail;
